module.exports = __webpack_public_path__ + "static/media/2.6c6ae918.png";